(function () {
  'use strict';

  if (window.pmcWiserFastScan) {
    window.pmcWiserFastScan(document);
    return;
  }

  var productSelector = [
    'a[href*="/products/"]',
    '[data-product-id] a[href]',
    '[data-product-handle] a[href]',
    '[class*="wiser_product"] a[href]',
    '[class*="wiser-product"] a[href]'
  ].join(',');

  // Only write when the value actually changes, so our own writes cannot keep
  // re-triggering the MutationObserver (no attribute is ever filtered out, so
  // Wiser's own changes to the same attributes are still seen).
  function setAttributeIfChanged(element, name, value) {
    if (element.getAttribute(name) !== value) element.setAttribute(name, value);
  }

  function removeAttributeIfPresent(element, name) {
    if (element.hasAttribute(name)) element.removeAttribute(name);
  }

  function optimizeDeferredImages(root) {
    if (!root || !root.querySelectorAll) return;

    Array.prototype.forEach.call(root.querySelectorAll('img'), function (image) {
      if (
        image.getAttribute('loading') === 'lazy' &&
        image.getAttribute('decoding') === 'async' &&
        image.getAttribute('fetchpriority') === 'low'
      ) return;

      if (image.getBoundingClientRect().top <= window.innerHeight + 200) return;
      if (image.getAttribute('loading') !== 'lazy') image.setAttribute('loading', 'lazy');
      if (image.getAttribute('decoding') !== 'async') image.setAttribute('decoding', 'async');
      if (image.getAttribute('fetchpriority') !== 'low') image.setAttribute('fetchpriority', 'low');
    });
  }

  function durationValue(slot, name, fallback, minimum) {
    var value = parseInt(slot.getAttribute(name) || String(fallback), 10);
    if (!isFinite(value) || value < minimum) return fallback;
    return value;
  }

  function uniqueProductLinks(app) {
    var seen = Object.create(null);

    return Array.prototype.filter.call(app.querySelectorAll(productSelector), function (link) {
      if (!link || !link.href) return false;

      var match = link.href.match(/\/products\/([^/?#]+)/);
      if (!match || seen[match[1]]) return false;

      seen[match[1]] = true;
      return true;
    });
  }

  function renderedHeight(app, productLinks) {
    var height = Math.max(app.scrollHeight || 0, app.getBoundingClientRect().height || 0);

    productLinks.slice(0, 5).forEach(function (link) {
      var node = link;
      var depth = 0;

      while (node && node !== app && depth < 6) {
        var rect = node.getBoundingClientRect();
        height = Math.max(height, rect.height || 0, node.scrollHeight || 0);
        node = node.parentElement;
        depth += 1;
      }
    });

    return height;
  }

  function hasUsableProducts(app) {
    if (!app) return false;

    var productLinks = uniqueProductLinks(app);
    if (!productLinks.length) return false;

    var text = (app.textContent || '').replace(/\s+/g, ' ').trim();
    var hasVisualContent = Boolean(
      app.querySelector('img, picture, [style*="background-image"], [data-product-id], [data-product-handle]')
    );

    return text.length > 8 && hasVisualContent && renderedHeight(app, productLinks) > 48;
  }

  function productImagesReady(app) {
    var productLinks = uniqueProductLinks(app);
    var images = [];

    productLinks.slice(0, 3).forEach(function (link) {
      var image = link.querySelector('img');
      if (image && images.indexOf(image) === -1) images.push(image);
    });

    if (!images.length) return true;

    return images.every(function (image) {
      return image.complete && image.naturalWidth > 0;
    });
  }

  function isSettledEmpty(app) {
    if (!app || hasUsableProducts(app)) return false;

    var widget = app.querySelector('[data-wiser-widget][data-widget-rendered="true"]');
    if (!widget) return false;

    return !widget.querySelector(
      '.ws-widget-loading, .ws-loading, .loading, [aria-busy="true"]'
    );
  }

  function dedupeWiserIds() {
    ['evmWiserWidegts', 'evm_quickViewModel'].forEach(function (id) {
      var nodes = Array.prototype.slice.call(document.querySelectorAll('[id="' + id + '"]'));

      nodes.slice(1).forEach(function (node) {
        if (!node.children.length && !(node.textContent || '').trim()) {
          node.remove();
        } else {
          node.removeAttribute('id');
        }
      });
    });
  }

  function refreshWidgetLayout() {
    window.dispatchEvent(new Event('resize'));
    window.dispatchEvent(new Event('scroll'));
    window.dispatchEvent(new CustomEvent('MutationObserverLoaded'));
  }

  function preserveSlotHeight(slot, app) {
    var reservedHeight = Math.ceil(slot.getBoundingClientRect().height || 0);
    if (reservedHeight < 1) return;

    var released = false;
    var resizeObserver = null;

    slot.style.minHeight = reservedHeight + 'px';

    function cleanup(removeReservation) {
      if (released) return;
      released = true;

      if (resizeObserver) resizeObserver.disconnect();
      window.removeEventListener('resize', handleViewportResize);

      if (removeReservation !== false) {
        slot.style.removeProperty('min-height');
      }
    }

    function checkHeight() {
      if (!slot.isConnected) {
        cleanup(false);
        return;
      }

      var appHeight = Math.ceil(
        Math.max(app.scrollHeight || 0, app.getBoundingClientRect().height || 0)
      );

      if (appHeight >= reservedHeight - 2) cleanup(true);
    }

    function handleViewportResize(event) {
      if (event && event.isTrusted) cleanup(true);
    }

    if ('ResizeObserver' in window) {
      resizeObserver = new ResizeObserver(checkHeight);
      resizeObserver.observe(app);
    }

    [0, 160, 500, 1000, 1800, 2800, 4200].forEach(function (delay) {
      window.setTimeout(checkHeight, delay);
    });

    window.addEventListener('resize', handleViewportResize);
  }

  function reveal(slot, app) {
    if (!slot || !app) return false;
    if (slot.classList.contains('is-wiser-ready')) return true;
    if (!hasUsableProducts(app)) return false;

    preserveSlotHeight(slot, app);

    slot.classList.remove('is-wiser-loading', 'is-wiser-empty');
    removeAttributeIfPresent(slot, 'aria-hidden');
    setAttributeIfChanged(slot, 'aria-busy', 'false');
    setAttributeIfChanged(app, 'aria-hidden', 'false');
    removeAttributeIfPresent(app, 'inert');
    slot.classList.add('is-wiser-ready');

    window.requestAnimationFrame(function () {
      window.requestAnimationFrame(function () {
        refreshWidgetLayout();
        dedupeWiserIds();
      });
    });

    [400, 1200, 2600].forEach(function (delay) {
      window.setTimeout(dedupeWiserIds, delay);
    });

    return true;
  }

  function markEmpty(slot) {
    if (!slot || slot.classList.contains('is-wiser-ready')) return;
    if (slot.classList.contains('is-wiser-empty')) return;

    slot.classList.remove('is-wiser-loading');
    setAttributeIfChanged(slot, 'aria-busy', 'false');
    setAttributeIfChanged(slot, 'aria-hidden', 'true');
    slot.classList.add('is-wiser-empty');

    var app = slot.querySelector('[data-pmc-wiser-app]');
    if (app) {
      setAttributeIfChanged(app, 'aria-hidden', 'true');
      setAttributeIfChanged(app, 'inert', '');
    }
  }

  function watch(slot) {
    if (!slot || slot.getAttribute('data-pmc-wiser-watched') === 'true') return;

    var app = slot.querySelector('[data-pmc-wiser-app]');
    if (!app) return;

    slot.setAttribute('data-pmc-wiser-watched', 'true');

    var timeoutMs = durationValue(slot, 'data-pmc-wiser-timeout', 8000, 4000);
    var skeletonDelayMs = durationValue(slot, 'data-pmc-wiser-skeleton-delay', 160, 0);
    var minimumVisibleMs = durationValue(slot, 'data-pmc-wiser-min-visible', 280, 0);
    var emptyGraceMs = durationValue(slot, 'data-pmc-wiser-empty-grace', 2200, 800);
    var mediaGraceMs = 650;
    var loadingSince = 0;
    var contentSince = 0;
    var lastMutationAt = Date.now();
    var checkTimer = 0;
    var revealTimer = 0;
    var skeletonTimer = 0;
    var emptyTimer = 0;
    var stopTimer = 0;
    var observer;
    var pollTimers = [];

    function clearTimer(timer) {
      if (timer) window.clearTimeout(timer);
    }

    function stopWatching() {
      clearTimer(checkTimer);
      clearTimer(revealTimer);
      clearTimer(skeletonTimer);
      clearTimer(emptyTimer);
      clearTimer(stopTimer);
      pollTimers.forEach(function (timer) {
        window.clearTimeout(timer);
      });
      pollTimers = [];
      app.removeEventListener('load', handleMediaEvent, true);
      app.removeEventListener('error', handleMediaEvent, true);
      if (observer) observer.disconnect();
    }

    function queueCheck(delay) {
      if (slot.classList.contains('is-wiser-ready') || checkTimer) return;

      checkTimer = window.setTimeout(function () {
        checkTimer = 0;
        checkState();
      }, delay || 0);
    }

    function scheduleReveal() {
      if (revealTimer || slot.classList.contains('is-wiser-ready')) return;

      var wait = 0;
      if (loadingSince) {
        wait = Math.max(0, minimumVisibleMs - (Date.now() - loadingSince));
      }

      revealTimer = window.setTimeout(function () {
        revealTimer = 0;

        if (reveal(slot, app)) {
          stopWatching();
        } else {
          queueCheck(0);
        }
      }, wait);
    }

    function checkState() {
      if (!slot.isConnected) {
        stopWatching();
        return;
      }

      dedupeWiserIds();
      optimizeDeferredImages(app);

      if (slot.classList.contains('is-wiser-ready')) return;

      if (hasUsableProducts(app)) {
        if (!contentSince) contentSince = Date.now();

        if (productImagesReady(app) || Date.now() - contentSince >= mediaGraceMs) {
          scheduleReveal();
        } else {
          queueCheck(80);
        }
        return;
      }

      contentSince = 0;
      clearTimer(revealTimer);
      revealTimer = 0;

      if (isSettledEmpty(app) && Date.now() - lastMutationAt >= emptyGraceMs) {
        markEmpty(slot);
      }
    }

    function handleMediaEvent() {
      queueCheck(0);
    }

    observer = new MutationObserver(function (records) {
      var meaningfulMutation = Array.prototype.some.call(records, function (record) {
        if (record.type === 'childList') {
          return record.addedNodes.length > 0 || record.removedNodes.length > 0;
        }

        return (
          record.type === 'attributes' &&
          (record.attributeName === 'data-widget-rendered' ||
            record.attributeName === 'aria-busy')
        );
      });

      if (meaningfulMutation) lastMutationAt = Date.now();
      optimizeDeferredImages(app);
      queueCheck(0);
    });

    observer.observe(app, {
      attributes: true,
      childList: true,
      subtree: true
    });

    app.addEventListener('load', handleMediaEvent, true);
    app.addEventListener('error', handleMediaEvent, true);

    skeletonTimer = window.setTimeout(function () {
      if (
        slot.classList.contains('is-wiser-ready') ||
        slot.classList.contains('is-wiser-empty')
      ) {
        return;
      }

      loadingSince = Date.now();
      slot.classList.add('is-wiser-loading');
    }, skeletonDelayMs);

    [0, 80, 160, 300, 500, 800, 1100, 1400, 1800, 2200, 3000, 4200, 5600].forEach(
      function (delay) {
        pollTimers.push(window.setTimeout(function () {
          queueCheck(0);
        }, delay));
      }
    );

    emptyTimer = window.setTimeout(function () {
      if (!reveal(slot, app)) markEmpty(slot);
    }, timeoutMs);

    stopTimer = window.setTimeout(function () {
      if (!reveal(slot, app) && observer) observer.disconnect();
    }, Math.max(timeoutMs + 22000, 30000));

    window.addEventListener('load', function () {
      queueCheck(0);
    }, { once: true });

    queueCheck(0);
  }

  function start(root) {
    dedupeWiserIds();

    // Image optimization is scoped in watch() to each Wiser app, avoiding a full-page image layout scan.
    var scope = root && root.querySelectorAll ? root : document;
    var slots = [];

    if (scope.matches && scope.matches('[data-pmc-wiser-fast]')) {
      slots.push(scope);
    }

    Array.prototype.push.apply(slots, scope.querySelectorAll('[data-pmc-wiser-fast]'));
    slots.forEach(watch);
  }

  window.pmcWiserFastScan = start;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      start(document);
    }, { once: true });
  } else {
    start(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    start(event.target || document);
  });
})();
